export default "__VITE_ASSET__4523c1bc__"